import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Flame, MapPin, Clock } from "lucide-react";

export const DestinationCard = ({ item, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.55, delay: 0.06 * index, ease: [0.2, 0.7, 0.2, 1] }}
      className="snap-center shrink-0 w-[78vw] sm:w-[300px] md:w-[320px]"
    >
      <Link
        to={`/itinerary/${item.id}`}
        data-testid={`destination-card-${item.id}`}
        className="block relative aspect-[9/16] rounded-3xl overflow-hidden group hover-lift ring-1 ring-white/10"
      >
        <img
          src={item.cover_image}
          alt={item.title}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 scrim-bottom" />

        {/* viral score badge */}
        <div className="absolute top-3 right-3 glass rounded-full px-2.5 py-1 flex items-center gap-1.5">
          <Flame className="h-3.5 w-3.5 text-[#FE0979]" />
          <span className="font-display font-bold text-xs text-white">{item.viral_score}</span>
        </div>

        {/* duration */}
        <div className="absolute top-3 left-3 glass rounded-full px-2.5 py-1 flex items-center gap-1.5">
          <Clock className="h-3 w-3 text-zinc-300" />
          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-zinc-200">{item.duration_days}d</span>
        </div>

        {/* bottom content */}
        <div className="absolute inset-x-0 bottom-0 p-4 sm:p-5">
          <div className="flex items-center gap-1.5 text-zinc-200/90 text-[10px] uppercase tracking-[0.2em] font-bold mb-2">
            <MapPin className="h-3 w-3" />
            <span>{item.destination}</span>
          </div>
          <h3 className="font-display font-black text-white text-xl sm:text-2xl leading-tight text-shadow-soft">
            {item.title}
          </h3>
          <div className="mt-3 flex flex-wrap gap-1.5">
            {(item.vibe_tags || []).slice(0, 3).map((t) => (
              <span key={t} className="text-[10px] font-bold uppercase tracking-[0.16em] text-white/90 bg-white/10 backdrop-blur rounded-full px-2 py-1 border border-white/15">
                {t}
              </span>
            ))}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
